import { render, staticRenderFns } from "./CartItemFlash.vue?vue&type=template&id=01594f6a&lang=pug&"
import script from "./CartItemFlash.vue?vue&type=script&lang=js&"
export * from "./CartItemFlash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports